
function getFormatedDate() {
    let dateObj = document.querySelector("input.form-control.flatpickr-input.input").value;
    var dt = parse_res_date(
        dateObj.split(' ')[0].split('-')[2],
        dateObj.split(' ')[0].split('-')[1],
        dateObj.split(' ')[0].split('-')[0],
        dateObj.split(' ')[1].split(':')[0],
        dateObj.split(' ')[1].split(':')[1]);
    var sMonth = convert_month(dt.getMonth() +1).toString().toUpperCase();
    var sDay = dt.getDate().toString();
    var li = sDay[sDay.length - 1];
    switch (li) {
        case "1": sDay += "ST"; break;
        case "2": sDay += "ND"; break;
        case "3": sDay += "RD"; break;
        default: sDay += "TH"; break;
    }
    return sMonth + " " + sDay + " " + dt.getFullYear().toString();
}
function toFix3(v) {    
    return  v.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]    
}
var lastSkyCbl =null;
var  bClbAdded = false;
// Initializing Celestial.js starmap script
function initSkyMap(initial) {
  if(!bClbAdded){
    bClbAdded = true;
    Celestial.addCallback(function (d) {        
      	lastSkyCbl = new Date().getTime();
      	
    });
  }
   var dt = new Date();
    if (initial && initial.dt) {
        let dateObj = initial.dt;
        dt = parse_res_date(
                   dateObj.split(' ')[0].split('-')[2],
                   dateObj.split(' ')[0].split('-')[1],
                   dateObj.split(' ')[0].split('-')[0],
                   dateObj.split(' ')[1].split(':')[0],
                   dateObj.split(' ')[1].split(':')[1]);
    }
  
    Celestial.display({
        adaptable: false, // Sizes are increased with higher zoom-levels
        interactive: false,
        controls: false,
        form: false,
        formFields: {
            download: true
        },
        datapath: "https://ofrohn.github.io/data/",
        timezoneid: "OZJZSV28I4V8",
        background: { // Background style
            fill: "#000000", // Area fill
            opacity: 1,
            stroke: "#ffffff", // Outline
            width: 2
        },
        stars: {
            style: {
                fill: "#ffffff",
                opacity: 1
            },
        },
        constellations: {
            lineStyle: {
                stroke: "#cccccc",
                width: 1,
                opacity: 0.6
            },
        },
    });


    
    //Date Picker using Flatpicker
    $("input.form-control.flatpickr-input.form-control.input").flatpickr({
      defaultDate: dt,
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        onChange: function (dateStr, dateObj) {
            set_res_date(
                dateObj.split(' ')[0].split('-')[2],
                dateObj.split(' ')[0].split('-')[1],
                dateObj.split(' ')[0].split('-')[0],
                dateObj.split(' ')[1].split(':')[0],
                dateObj.split(' ')[1].split(':')[1]);
        },
        onReady: function (selectedDates, dateStr, instance) {
            //var rd = initial && initial.dt ? initial.dt : instance.formatDate(new Date(), 'Y-m-d H:i');
            //$('input.form-control.flatpickr-input.form-control.input').val(                rd                     )
        },
    });
}

function changeColor(val) {
    document.querySelector('#background-fill').value = val.value;
    trigger_change_event("background-fill");
}


function convert_month(month) {
    var months = ['test', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[month];
}

function goSkyview(dt,loc){
    Celestial.skyview({
        date: dt, location: loc,
        timezone: 0
    });
}

//Google Places API
function initialize() {
    var input = document.getElementById('address_form1');
    var autocomplete = new google.maps.places.Autocomplete(input);
  	$(input).data("ws",false);
    google.maps.event.addListener(autocomplete, 'place_changed', function() {
      	$(input).data("ws",true);
        var place = autocomplete.getPlace();
        //Celestial.location([place.geometry.location.lat(), place.geometry.location.lng()])
        goSkyview(Celestial.date(), [place.geometry.location.lat(), place.geometry.location.lng()]);
        let lat_1 = (place.geometry.location.lat()).toFixed(4);
        let lng_1 = (place.geometry.location.lng()).toFixed(4);
    });
}

//google.maps.event.addDomListener(window, 'load', initialize);

function show_moon() {
    var showMoon = document.getElementById("cb35").checked;
    document.getElementById("planets-show").checked = showMoon;
    trigger_change_event("planets-show");
}

function show_grid() {
    var showGrid = document.getElementById("cb1").checked;
    document.getElementById("lines-graticule-show").checked = showGrid;
    trigger_change_event("lines-graticule-show");
}

// Constellations
function change_constellations() {
    var showConst = document.getElementById("cb2").checked;
    document.getElementById("constellations-lines").checked = showConst;
    trigger_change_event("constellations-lines")
}

function show_milkyway() {
    var showMoon = document.getElementById("cb3").checked;
    document.getElementById("mw-show").checked = showMoon;
    trigger_change_event("mw-show");
}

function trigger_change_event(element_id) {
    element = document.getElementById(element_id);
    var event = new Event('change');
    element.dispatchEvent(event);
}

function set_date() {
    dates('option');
    months('option');
    var d = new Date();
    var year = d.getFullYear();
    years('option', year - 70, year + 10);
    var month = convert_month(d.getMonth() + 1);
    document.getElementById("inputmonth").value = month;
    document.getElementById("inputyear").value = d.getFullYear();
    document.getElementById("inputday").value = d.getDate();
    on_date_change();
}

function on_date_change() {
    var month = document.querySelector("input.form-control.flatpickr-input.input").value.split(' ')[0]
    var year = document.querySelector("input.form-control.flatpickr-input.input").value.split(' ')[2]
    var day = document.querySelector("input.form-control.flatpickr-input.input").value.split(' ')[1]
    set_res_date(day, month, year);
}

function set_res_date(day, monthh, year, hour12, min12) {
    var month_list = ['test', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    month = monthh;// month_list.indexOf(monthh);
    month_str = month;
    if (month <= 9) {
        month_str = "0" + month_str;
    }
    day_str = day;

    if (day <= 9) {
        day_str = "0" + day_str;
    }

    month_val = month - 1;

    var t_hr = hour12;

    var t_min = min12;

    //var d = new Date(parseInt(year), parseInt(month_str) - 1, parseInt(day_str), parseInt(t_hr), parseInt(t_min))
    //Celestial.date(d, Celestial.timezone())
    var d = new Date(parseInt(year), parseInt(month_str) - 1, parseInt(day_str), parseInt(t_hr), parseInt(t_min));
    Celestial.date(d, 0)
    var showHr = t_hr;
    var showMin = t_min;
    if (t_hr > 12) {
        showHr = t_hr - 12;
    }
    if (t_hr > 23 || t_hr < 0) {
        showHr = 00;
        $('#hr_form').val(0)
        t_hr = 0;
        $("#hr").val(t_hr);
        trigger_change_event("hr");
    }

    if (t_min > 59 || t_min < 0) {
        $('#min_form').val(0)
        t_min = 0;
        $("#min").val(t_min);
        trigger_change_event("min");
    }
}

function parse_res_date(day, monthh, year, hour12, min12) {
    var month_list = ['test', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    month = monthh;// month_list.indexOf(monthh);
    month_str = month;
    if (month <= 9) {
        month_str = "0" + month_str;
    }
    day_str = day;

    if (day <= 9) {
        day_str = "0" + day_str;
    }

    month_val = month - 1;

    var t_hr = hour12;

    var t_min = min12;

    var d = new Date(parseInt(year), parseInt(month_str) - 1, parseInt(day_str), parseInt(t_hr), parseInt(t_min));
    return d;
   
}
